import requests from './httpService';

const PushNotificationService = {
  sendNotification(body) {
    return requests.post('/pushnotification/send', body);
  },
  listParentNotifications(classId) {
    const query = classId ? `?classId=${encodeURIComponent(classId)}` : '';
    return requests.get(`/pushnotification/parent${query}`);
  },
  listAdminNotifications() {
    return requests.get(`/pushnotification/admin`);
  },
  updateAdminNotification(id, body) {
    return requests.put(`/pushnotification/admin/${id}`, body);
  },
  deleteAdminNotification(id) {
    return requests.delete(`/pushnotification/admin/${id}`);
  },
};

export default PushNotificationService;

